export class Serializer {
    public static serialize(target: any): string {
        return JSON.stringify(target, Serializer.transformString)
    }

    public static deSerialize(target: string): any {
        return JSON.parse(target, Serializer.transformObject)
    }

    private static transformString(_key: any, value: any): any {
        return value instanceof Map ? {
            dataType: 'Map',
            value: [...value]
        } : value
    }

    private static transformObject(_key: any, value: any): any {
        return typeof value === 'object' && value?.dataType === 'Map'
            ? new Map(value.value)
            : value
    }
}